import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozAddress'
})
export class BringozAddressPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService, @Inject('splitService') private splitService,
              @Inject('commonsService') private commonsService) {
  }

  transform(address: any, noValueEnabled?: boolean): string {
    if (address) {
      const countryCode = this.splitService.getCountryCode();
      let formattedAddress = '';

      const house = _.get(address, 'house', '');
      const street = _.get(address, 'street', '');
      const neighborhood = _.get(address, 'neighborhood', '');
      const city = _.get(address, 'city', '');
      const state = _.get(address, 'state', '');
      const zipCode = _.get(address, 'zipCode', '');

      if (countryCode === 'IL') {
        if (street) {
          formattedAddress += street;
          if (house) {
            formattedAddress += (' ' + house);
          }
        }
        if (city) {
          formattedAddress += (', ' + city);
        }
      } else {
        if (street) {
          if (house) {
            formattedAddress += (house + ' ');
          }
          formattedAddress += street;
        }
        if (countryCode === 'GB') {
          if (neighborhood) {
            formattedAddress += (', ' + neighborhood);
          }
        } else {
          if (city) {
            formattedAddress += (', ' + city);
          }
          if (neighborhood) {
            formattedAddress += (', ' + neighborhood);
          }
        }
        if (state) {
          formattedAddress += (', ' + state);
          if (zipCode) {
            formattedAddress += (' ' + zipCode);
          }
        } else {
          if (zipCode) {
            formattedAddress += (', ' + zipCode);
          }
        }
      }

      return this.commonsService.capitalize(formattedAddress);
    } else {
      return noValueEnabled ? undefined : this.translateService.instant('No Address');
    }
  }
}
